import { Directive, DirectiveBinding } from 'vue';

/**
 * 요소 외부를 클릭했을 때 지정된 함수를 실행하는 디렉티브
 * 사용법: v-click-outside="handlerFunction"
 */
export const clickOutsideDirective: Directive = {
    mounted(el: HTMLElement, binding: DirectiveBinding) {
        (el as any)._clickOutside = (event: MouseEvent) => {
            // 클릭된 요소가 현재 요소 또는 그 자식 요소가 아닌 경우에만 핸들러 실행
            if (!(el === event.target || el.contains(event.target as Node))) {
                binding.value(event);
            }
        };
        document.addEventListener('click', (el as any)._clickOutside);
    },
    unmounted(el: HTMLElement) {
        document.removeEventListener('click', (el as any)._clickOutside);
    },
};
